export default __webpack_public_path__ + "static/media/jap-ecommerceImg_2.c2874d32.webp";